module.exports = __webpack_public_path__ + "static/media/send.d9f34237.svg";